/**
 * Global HubSpot CBE tracker.
 *
 * 1. "Added to Cart" — intercepts all POST /cart/add requests (fetch + XHR)
 * 2. "Started Checkout" — intercepts checkout link clicks + Buy Now redirects
 * 3. "Clicked Book Appointment" — tracks clicks on [data-hs-track="book-appointment"] CTAs
 *
 * Logged-in customers only (reads window.__teddy.customerEmail).
 */
(function () {
  var API_BASE = 'https://teddy-baldassarre-git-hubspot-wishlist-cbe-teddy-baldassarre.vercel.app';
  var origFetch = window.fetch;
  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;

  function getEmail() {
    return window.__teddy && window.__teddy.customerEmail;
  }

  function isCartAdd(method, url) {
    return method === 'POST' && typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  /* ---- Added to Cart tracking ---- */

  function trackItems(items) {
    var email = getEmail();
    if (!email) return;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var variantId = item.variant_id || item.id;
      if (!variantId) continue;

      origFetch(API_BASE + '/api/hubspot-track-add-to-cart', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          variantId: String(variantId),
          quantity: item.quantity || 1,
        }),
      }).catch(function () {});
    }
  }

  function parseAndTrack(json) {
    try {
      var data = typeof json === 'string' ? JSON.parse(json) : json;
      var items = data.items || [data];
      trackItems(items);
    } catch (_) {}
  }

  /* ---- Started Checkout tracking ---- */

  function trackStartedCheckout(cartData, source) {
    var email = getEmail();
    if (!email) return;
    if (!cartData || !cartData.items || !cartData.items.length) return;

    origFetch(API_BASE + '/api/hubspot-track-started-checkout', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        email: email,
        cart: cartData,
        source: source || 'checkout_button',
        locale: navigator.language || '',
      }),
    }).catch(function () {});
  }

  /**
   * Build a synthetic /cart.js-shaped object from the /cart/add.js response.
   * Used for Buy Now so we don't need a second async /cart.js fetch.
   */
  function buildSyntheticCart(addResponseJson) {
    var items = addResponseJson.items || [addResponseJson];
    var totalPrice = 0;
    var itemCount = 0;
    for (var k = 0; k < items.length; k++) {
      totalPrice += (items[k].final_line_price || items[k].line_price || items[k].price || 0);
      itemCount += (items[k].quantity || 1);
    }
    return {
      items: items,
      item_count: itemCount,
      total_price: totalPrice,
      total_discount: 0,
      currency: (items[0] && items[0].currency) || 'USD',
    };
  }

  /* ---- Intercept fetch ---- */

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || 'GET').toUpperCase();

    if (isCartAdd(method, url)) {
      return origFetch.apply(this, arguments).then(function (response) {
        if (response.ok) {
          response.clone().json().then(function (json) {
            // Fire "Added to Cart" CBE
            parseAndTrack(json);

            // Buy Now detection: uses /cart/add.js (with .js extension)
            // Regular add-to-cart uses /cart/add (without .js)
            if (typeof url === 'string' && url.indexOf('/cart/add.js') !== -1) {
              var syntheticCart = buildSyntheticCart(json);
              trackStartedCheckout(syntheticCart, 'buy_now');
            }
          }).catch(function () {});
        }
        return response;
      });
    }

    return origFetch.apply(this, arguments);
  };

  /* ---- Intercept XMLHttpRequest (axios) ---- */

  XMLHttpRequest.prototype.open = function (method, url) {
    this._hsMethod = (method || '').toUpperCase();
    this._hsUrl = url;
    return origXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (isCartAdd(this._hsMethod, this._hsUrl)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          parseAndTrack(this.responseText);
        }
      });
    }
    return origXHRSend.apply(this, arguments);
  };

  /* ---- Intercept checkout link clicks ---- */

  function attachCheckoutListeners() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href*="/checkout"]');
      if (!link) return;
      if (!getEmail()) return;

      e.preventDefault();

      var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      origFetch(routes + 'cart.js', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
      })
        .then(function (res) { return res.json(); })
        .then(function (cartData) {
          trackStartedCheckout(cartData, 'checkout_button');
        })
        .catch(function () {})
        .then(function () {
          // Always navigate, even if tracking failed
          window.location.href = link.href;
        });
    }, true); // useCapture to run before other handlers
  }

  /* ---- Track "Book Appointment" CTA clicks ---- */

  function attachBookAppointmentListeners() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-hs-track="book-appointment"]');
      if (!link) return;

      var email = getEmail();
      if (!email) return;

      origFetch(API_BASE + '/api/hubspot-track-book-appointment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          email: email,
          pageUrl: window.location.href,
          ctaText: link.textContent.trim(),
          destinationUrl: link.href || '',
        }),
      }).catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      attachCheckoutListeners();
      attachBookAppointmentListeners();
    });
  } else {
    attachCheckoutListeners();
    attachBookAppointmentListeners();
  }
})();
